export default "__VITE_ASSET__BI$zNoZc__"